import React from 'react';
import DOMPurify from 'dompurify';

interface FeedbackContentProps {
    html: string;
}

const FeedbackContent: React.FC<FeedbackContentProps> = ({ html }) => (
    <div
        className="text-sm text-gray-700 dark:text-gray-200 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:text-blue-600 [&_a]:underline"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
    />
);

export default FeedbackContent;
